import { launchAsyncQuickshop } from '@product/js/utils/asyncLaunchers';
import { productQuickshopOptions } from '@product/js/utils/productQuickshopOptions';

import template from 'product-shop-the-look.j2';

import { generate, templateLocationExists } from '../../../core/js/utils/componentUtils';
import { getDefaultOptions } from '../../../core/js/utils/a15componentUtils';
import { onStateChange } from '../utils/productComponentUtils';

import { shopTheLookSwiperInit } from '../../js/utils/swiperInits';

import { favoriteClicked } from '../../../core/js/utils/favoritesUtils';

function afterRender(store) {
    shopTheLookSwiperInit.bind(this)(store);
}

/* There is a white lable requirement to have the entire image link open
    quickshop, this functionality has been removed for Anthro requirements.
    If UO still requires this it will need a brand override. */

export function attachEvents(store) {
    $(document).on(
        this.scopedEvent('touchend click'),
        this.scopedSelector('.js-product-tile-control-quickshop'),
        (event) => {
            event.preventDefault();

            const productIndex = $(event.target).parents('.js-product-tile')
                .attr('data-product-index');
            const records = _.map(
                this.getTargetedProduct(store.getState()).shopTheLook.products,
                (product) => product
            );

            launchAsyncQuickshop(store, productQuickshopOptions, event, records, productIndex);
        }
    );
    $(document).on(
        this.scopedEvent('touchend click'),
        this.scopedSelector('.js-favorite-toggle'),
        (e) => favoriteClicked(store, e)
    );
}

/**
 * Bootstrap the component onto the page
 */
export function init(store, overrides = {}) {
    const config = {
        watch: 'product.shopTheLook',
        template: template,
        templateLocation: '.dom-pdp .dom-product-shop-the-look',
        onStateChange: onStateChange,
        attachEvents: attachEvents,
        afterRender: afterRender,
        replace: true,
        afterConstruction: shopTheLookSwiperInit,
        isComponentValid: templateLocationExists
    };

    return generate(config, store, overrides, getDefaultOptions(store));
}
